export function getCPUrlFromNewbuildingGaLabel(
  gaLabelFull: string,
) {
  return `/sale/JK${gaLabelFull}`;
}
